import { FAIcon } from '~/components/utils/FAIcons';

const MOCK_MESSAGES: Array<{ from: 'assistant' | 'user'; text: string }> = [
	{ from: 'user', text: 'What jobs are due this week?' },
	{
		from: 'assistant',
		text: 'You have 7 jobs scheduled this week. Three installs at Harbor Office, two measures, and two service calls. Want me to pull up the installs first?',
	},
	{ from: 'user', text: 'Yes, show installs sorted by start time.' },
	{
		from: 'assistant',
		text: 'Harbor Office at 9:15 AM Tuesday, Maple Heights at 11:00 AM Wednesday, and Sunset Tower at 8:30 AM Friday. All have signed contracts.',
	},
];

export const GlazierChatMock = () => {
	return (
		<div className="flex h-full w-full flex-col bg-popover">
			<div className="flex h-12 shrink-0 items-center border-b px-4">
				<div className="size-8" />
				<h2 className="flex-1 text-center font-semibold text-base text-foreground">Glazier Assistant</h2>
				<div className="size-8" />
			</div>
			<div className="flex flex-1 flex-col gap-3 overflow-hidden p-4">
				{MOCK_MESSAGES.map((message, idx) => (
					<div className={`flex ${message.from === 'user' ? 'justify-end' : 'justify-start'}`} key={idx}>
						<div
							className={`max-w-[80%] rounded-2xl px-3 py-2 text-sm ${
								message.from === 'user' ? 'bg-primary text-white' : 'bg-gray-100 text-gray-900'
							}`}
						>
							{message.text}
						</div>
					</div>
				))}
			</div>
			<div className="border-t p-3">
				<div className="flex items-center gap-2 rounded-full border border-gray-200 bg-white px-3 py-2 text-sm text-gray-400">
					<span className="flex-1">Ask the assistant…</span>
					<FAIcon icon="paper-plane" />
				</div>
			</div>
		</div>
	);
};
